import { reactive } from "@vue/composition-api"

interface ProgressExchangeBus {
    progress: string[]
}

const progressExchangeBus: ProgressExchangeBus = reactive<ProgressExchangeBus>({
    progress: []
})

export function useProgressExchangeBus(): ProgressExchangeBus {
    return progressExchangeBus
}